<template>
    <b-list-group-item class="px-0 py-2 flex-column align-items-start">
      <div class="d-flex w-100 justify-content-between">
        <h6 class="mb-1"><small class="font-weight-bold">{{ node.name }}</small></h6>
        <small class="font-weight-bold">{{ node.created }}</small>
      </div>
      <template v-for="(detail, index) in filteredDetails">
      	 <p class="mb-0 break-word small" :key="index">{{ detail }}</p>
      </template>
      <!-- <small>Additional details or info.</small> -->
      <b-list-group v-if="node.children" class="ml-4 my-1">
        <tree-node v-for="(child, index) in node.children" :key="index" :node="child"/>
      </b-list-group>
    </b-list-group-item>
</template>

<script>
import { useICPC, useICD10 } from '@/shared/clinicCodes'

export default {
	name: "tree-node",
	props: {
		node: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			useICPC,
			useICD10
		}
	},
	computed: {
		filteredDetails() {
			if (!this.node.details || !Array.isArray(this.node.details)) {
				return []
			}
			
			const icpc = this.node.details.find(detail => detail && detail.startsWith('ICPC'))
			const icd10 = this.node.details.find(detail => detail && detail.startsWith('ICD-10'))
			
			// Filter based on environment setting
			const codeDetails = []
			if (this.useICPC && icpc) {
				codeDetails.push(icpc)
			}
			if (this.useICD10 && icd10) {
				codeDetails.push(icd10)
			}
			
			// If we have code details, return them
			if (codeDetails.length > 0) {
				return codeDetails
			}
			
			// For other details (not ICPC/ICD10), show all non-null values
			return this.node.details.filter(detail => detail != null && detail !== '')
		}
	}
}
</script>
<style>
.ml-4 {
  margin-left: 1.5rem;
}
</style>